import { useCallback } from 'react';

import { PaymentTabData } from '@/features/settings/types';
import { useCreateStripePortalSessionMutation, useGetCurrentUserSubscription } from '@/shared/hooks/queries/generated';

export const usePaymentTabData = (): PaymentTabData => {
  // Queries
  const { data: currentUserSubscriptionData } = useGetCurrentUserSubscription(
    {},
    {
      refetchInterval: 5000,
    },
  );

  // Mutations
  const createPortalSession = useCreateStripePortalSessionMutation();

  // Handle payment method and invoices
  const handlePaymentMethodAndInvoices = useCallback(async () => {
    try {
      const result = await createPortalSession.mutateAsync({
        input: {
          type: 'paymentMethodAndInvoices',
          returnUrl: window.location.href,
        },
      });

      if (result.createStripePortalSession.url) {
        window.location.href = result.createStripePortalSession.url;
      }
    } catch (error) {
      console.error('Error creating payment portal session:', error);
      throw error;
    }
  }, [createPortalSession]);

  // Handle subscription cancel
  const handleSubscriptionCancel = useCallback(async () => {
    try {
      const result = await createPortalSession.mutateAsync({
        input: {
          type: 'subscriptionCancel',
          returnUrl: window.location.href,
        },
      });

      if (result.createStripePortalSession.url) {
        window.location.href = result.createStripePortalSession.url;
      }
    } catch (error) {
      console.error('Error creating cancellation portal session:', error);
      throw error;
    }
  }, [createPortalSession]);

  const userSubscription = currentUserSubscriptionData?.getCurrentUserSubscription;

  return {
    handlePaymentMethodAndInvoices,
    handleSubscriptionCancel,
    showCancelButton: !userSubscription?.inactivatedAt,
    cancelAt: userSubscription && userSubscription.inactivatedAt ? new Date(userSubscription.inactivatedAt) : null,
  };
};
